<template>
  <v-card flat outlined class="rounded-10 overflow-y-auto" max-height="85vh">
    <v-card-title>
      <v-icon class="mr-2">mdi-magnify</v-icon>
      Look Up Session
      <v-progress-circular v-if="loading" class="ml-2" indeterminate />
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="searchForSession">
        <v-row class="mt-2">
          <v-col cols="7" class="d-flex">
            <v-text-field
              v-model="search"
              clearable
              label="Session Reference"
              outlined
              class="rounded-lg"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="5" class="d-flex align-center">
            <v-spacer />
            <v-btn class="btn-primary mr-2" @click="searchForSession()">
              Search
            </v-btn>
            <v-btn class="btn-error" @click="clearSearch()"> Clear </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <div
        class="text-center my-10"
        v-if="searched && searchResults.length === 0"
      >
        No Results for: {{ search }}
      </div>
      <v-simple-table v-if="searched && searchResults.length > 0">
        <thead>
          <tr>
            <th>Reference</th>
            <th>Identity</th>
            <th>Type</th>
            <th>Result</th>
            <th>Kit #</th>
            <th class="text-right">Time</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(session, index) in searchResults"
            :key="index"
            @click="$emit('open', session)"
            style="cursor: pointer"
          >
            <td>
              <strong>{{ session.reference_number }}</strong>
            </td>
            <td>{{ actorName(session) }}</td>
            <td>{{ session.session_type }}</td>
            <td>
              {{ session.score.toPrecision(4) }}
              <v-chip
                label
                x-small
                color="success"
                v-if="session.score >= thresholds.PASS"
                >Pass</v-chip
              >
              <v-chip
                label
                x-small
                color="error"
                v-else-if="session.score < thresholds.CONSIDER_RESCAN"
                >Fail</v-chip
              >
              <v-chip label x-small color="warning" v-else>Warn</v-chip>
            </td>
            <td>{{ session.kit_serial_number }}</td>
            <td class="text-right">
              {{ session.created_at | luxon({ output: "tz_med" }) }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { prettyIDName } from "@/utils"
import { THRESHOLDS } from "@osteon-nexus-connect-lib/nc-frontend"

export default {
  name: "LookupSession",

  data() {
    return {
      loading: false,
      search: null,
      searched: false,
      searchResults: []
    }
  },

  computed: {
    thresholds() {
      return THRESHOLDS
    }
  },

  methods: {
    actorName(session) {
      return prettyIDName(session.actor_payload)
    },

    async searchForSession() {
      this.loading = true
      const response = await this.$axios.get(
        `/proxy/admin/sessions/?search=${this.search}`
      )
      this.searched = true
      this.searchResults = response.data
      this.loading = false
    },

    clearSearch() {
      this.search = null
      this.searched = false
      this.searchResults = []
    }
  }
}
</script>
